import React from 'react'
import { Outlet } from 'react-router-dom'
import Navigation from '../Dashboard/Navigation/Navigation'
import UpBtn from '../UpBtn/UpBtn'


export default function LayoutDashboard() {
  return (
    <>
      <Navigation/>
            <UpBtn/>
      
    </>
  )
}
